import { logger } from '~/src/common/services/Logger';
import { Image as ImageType, ImageParams } from '~/src/common/typings/image';
import { getImageUrl } from '~/src/common/utils/cloudinary';

export const getInfoImageUrl = (image?: { media: string } | null, isPage = false) => {
  const imageJson = image?.media;
  let imageUrl = '';

  if (imageJson) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment  -- auto-ignored when updating eslint
      const parsedImage: ImageType = JSON.parse(imageJson);

      imageUrl = getImageUrl(
        parsedImage.url,
        isPage ? ImageParams.banner : ImageParams.marketingModalBanner,
      );
      return imageUrl;
    } catch (err) {
      logger.error('JSON Exception', { originalError: err as SyntaxError });
    }
  }
  return imageUrl;
};
